import React from 'react';
import { connect } from "react-redux";
import $ from "jquery";
import {hashHistory} from "react-router";

import {INITIAL_FLOW_BUTTON_TYPES} from "../../reducers/initialFlowReducer";
import {setInitialFlowType, setInitialFlowStep} from "../../actions/initialFlowFunctions";

class InitialFlow extends React.Component {

  componentDidMount() {
    this.props.setInitialFlowStep(0);
    $(".flow-buttons").fadeIn(300);
  }

  handleInitialButtonClick = (button) => {
    this.props.setInitialFlowType(button);
    $(".flow-buttons").fadeOut(300, () => {
      hashHistory.push("/wizard/room");
    });
  };

  render() {
    return (
      <div className="flow-buttons">
        {Object.keys(INITIAL_FLOW_BUTTON_TYPES).map(buttonType => (
          <button className={"flow-buttons__button flow-buttons__button--" + buttonType.toLowerCase()
          + (this.props.initialFlowType === buttonType ? " flow-buttons__button--selected" : "")}
                  key={buttonType}
                  onClick={() => this.handleInitialButtonClick(buttonType)}>
                <span className="flow-buttons__button-text bold">
                  {buttonType === INITIAL_FLOW_BUTTON_TYPES.Quote ? "Get A Quote" : buttonType}
                </span>
          </button>
        ))}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    initialFlowType: store.initialFlowState.initialFlowType,
  };
};

export default connect(mapStateToProps, {
  setInitialFlowType,
  setInitialFlowStep
})(InitialFlow);
